var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alertMsg"},[_vm._v("Вы разлогинены. Пожалуйста, "),_c('a',{attrs:{"href":"/"}},[_vm._v("авторизуйтесь заново")]),_vm._v(".")])}]

export { render, staticRenderFns }